export const FETCH_STUDENT_TUTORIALS = 'FETCH_STUDENT_TUTORIALS';
export const DELETE_STUDENT_TUTORIAL = 'DELETE_STUDENT_TUTORIAL';